{
  "headings": {
    "tenantLeaves_one": "Yksi henkilö muuttaa pois",
    "tenantLeaves_other": "{{count}} henkilöä muuttaa pois",
    "modificationPreview": "Muutoksien esikatselu",
    "thankYou": "Kiitos",
    "confirmationRejected": "Muutosilmoitus on hylätty.",
    "addTenant": "Lisää asukas",
    "residentChangeType": "Mitä haluat ilmoittaa?",
    "whoMovesOut": "Kuka muuttaa pois?",
    "contractPartiesMovingOut": "Ketkä sopimusosapuolet muuttavat pois?",
    "contractTransfer": "Sopimuksen siirto"
  },
  "view": {
    "title": "Sopimusmuutokset"
  },
  "residentChanges": {
    "title": "Asukasmuutokset",
    "description": "Ilmoita tällä sivulla, kun asuntoosi muuttaa uusi asukas tai kun asukas, joka ei ole sopimusosapuoli, muuttaa pois. Sopimus jatkuu ennallaan.",
    "terminationInfo": "Jos sinä tai toinen sopimusosapuoli muuttaa pois, tee irtisanominen.",
    "rightOfOccupancyNoticeInfo": "Jos sinä tai toinen sopimusosapuoli muuttaa pois, tee luovutusilmoitus.",
    "moveIn": "Sisäänmuutto",
    "moveInDescription": "Sisäänmuutto – lisää asuntoon uusi asukas.",
    "moveOut": "Poismuutto",
    "moveOutDescription": "Poismuutto – ilmoita, että asukas, joka ei ole sopimusosapuoli, muuttaa pois.",
    "pendingContractChanges": "Et voi ilmoittaa asukasmuutoksia ennen kuin edelliset sopimusmuutokset astuvat voimaan."
  },
  "tenantChoices": {
    "lives": "Asuu",
    "movesOut": "Muuttaa pois",
    "staysInApartment": "Jää asumaan",
    "contractParty": "Sopimusosapuoli",
    "currentUserName": "{{name}} (sinä)"
  },
  "tenantRoles": {
    "tenant": "Asukas",
    "subtenant": "Alivuokralainen",
    "replacementApartmentTenant": "Väistöasunnon asukas",
    "legalGuardian": "Huoltaja",
    "secondaryTenant": "Jälleenvuokralainen",
    "minor": "{{role}}, alle 18 v"
  },
  "labels": {
    "movingOutDate": "Poismuuttopäivä",
    "modificationDescription": "Lisätiedot",
    "transferDestination": "Kenen nimiin haluat siirtää sopimuksen",
    "movingOutTenant": "Poismuuttaja",
    "newContractParty": "Uusi sopija",
    "socialSecurityNumber": "Henkilötunnus",
    "firstName": "Etunimi",
    "lastName": "Sukunimi",
    "email": "Sähköposti",
    "phoneNumber": "Puhelinnumero",
    "change": "Muutos",
    "personAdded": "Henkilö lisätty",
    "personInformation": "Henkilön tiedot",
    "contractEnds": "Päättyy",
    "contractEnded": "Päättynyt"
  },
  "placeholders": {
    "modificationDescription": "Voit halutessasi kertoa lisätietoja"
  },
  "buttons": {
    "backToEdit": "Takaisin muokkaamaan",
    "confirmModification": "Vahvista sopimusmuutokset",
    "rejectModification": "Hylkää sopimusmuutokset",
    "back": "Takaisin",
    "addPerson": "Lisää henkilö",
    "restart": "Aloita alusta"
  },
  "links": {
    "goToTerminateContract": "Siirry irtisanomaan →",
    "goToRightOfOccupancyNotice": "Siirry tekemään luovutusilmoitus →",
    "seeTerminateContract": "Katso Irtisano sopimus →"
  },
  "texts": {
    "confirmationInstruction": "Tarkasta syötetyt tiedot ja hyväksy tai hylkää sopimusmuutokset. Jos tietoja pitää muokata, hylkää sopimusmuutokset ja täytä irtisanomislomake uudelleen.",
    "tenantLeavingDescription": "Sopimus jää voimaan ja vastuu huoneistosta siirtyy muille sopimusosapuolille.",
    "confirmationAccepted": "Muutosilmoitus on sinun osaltasi vahvistettu.",
    "terminationRequestExists": "Tälle sopimukselle on jo tehty irtisanomisilmoitus.",
    "returnFromAuthReminder": "Muistathan, että sopimusmuutosilmoitus lähtee käsittelyyn vasta, kun olet tunnistautunut vahvasti ja palannut takaisin asukassivuille. Jos tunnistautuminen keskeytyy, sopimusmuutos jää keskeneräiseksi.",
    "otherContractPartyTerminationInfo": "Toisen sopimusosapuolen voi irtisanoa vain irtisanomalla koko sopimuksen. Valitse silloin Koko sopimus päättyy.",
    "selectMovingOutTenants": "Valitse henkilöt, jotka muuttavat pois.",
    "contractPartyMoveOut": "Jos sopimusosapuoli muuttaa pois, tee irtisanominen Irtisano sopimus -sivulla.",
    "rightOfOccupancyNoticeContractPartyMoveOut": "Jos sopimusosapuoli muuttaa pois, tee luovutusilmoitus Irtisano sopimus -sivulla.",
    "moveOutDateRange": "Valitse päivä väliltä {{start}}–{{end}}.",
    "monthEndMoveOutDate": "Valitse kuukauden viimeinen päivä, aikaisintaan {{date}}.",
    "addTenantDescription": "Lisää asuntoon muuttavan henkilön tiedot.",
    "contractTransferInfo": "Sopimus jatkuu ja vastuu huoneistosta siirtyy valitsemallesi henkilölle. Muutos lähtee käsittelyyn, kun kaikki osapuolet ovat vahvistaneet sen."
  },
  "terminationDisallowedReasons": {
    "pending": "Odottaa",
    "endsOn": "Päättyy {{date}}",
    "contract_terminated": "Sopimus on jo irtisanottu.",
    "pending_termination_tenant_approvals": "Kaikki asukkaat eivät ole vielä hyväksyneet irtisanomista.",
    "pending_termination_review": "Irtisanomisilmoitus odottaa käsittelyä kiinteistöyhtiössä.",
    "is_estate_contract": "Kyseessä on kuolinpesän sopimus.",
    "has_guardian_of_interests": "Jollakin sopijaosapuolella on edunvalvoja.",
    "missing_resident_users": "Kaikilla sopijaosapuolilla ei ole asukassivujen käyttäjätunnusta.",
    "contract_tag": "Sopimuksella on irtisanomisen estävä tunniste.",
    "not_contract_party": "Et ole tämän sopimuksen sopimusosapuoli.",
    "tenants_with_undetermined_age": "Sopimuksella on asukkaita, joiden ikä puuttuu.",
    "has_company_tenant": "Sopimuksella on yritysosapuoli.",
    "pending_modification_request": "Avoinna oleva sopimusmuutospyyntö estää irtisanomisen.",
    "not_started_yet": "Sopimus ei ole vielä alkanut.",
    "open_continuation_offer": "Avoinna oleva jatkotarjous estää irtisanomisen."
  },
  "confirmationError": {
    "noIdentityVerifier": "Käyttäjän henkilöllisyyttä ei voitu varmentaa",
    "noIdentity": "Käyttäjän henkilöllisyyttä ei voitu käsitellä",
    "noUser": "Käyttäjän tietojen haussa tapahtui virhe",
    "noAttributes": "Käyttäjän henkilötiedot ovat puutteelliset",
    "identityMismatch": "Henkilöllisyys ei täsmää kirjautuneeseen käyttäjään",
    "initFailed": "Sopimusmuutosilmoituksen vahvistamisessa tapahtui virhe",
    "cancelled": "Tunnistautuminen peruutettu",
    "addTenantInitFailed": "Asukkaan lisääminen epäonnistui"
  },
  "errors": {
    "outOfService": "Valitettavasti sopimusmuutos ei ole tällä hetkellä mahdollista. Yritä myöhemmin uudelleen.",
    "formErrorTitle": "Virhe sopimusmuutosilmoituksen lähetyksessä",
    "confirmErrorTitle": "Virhe sopimusmuutosilmoituksen vahvistamisessa",
    "pending_contract_resign": "Sopimus odottaa uudelleenallekirjoitusta."
  },
  "confirmationState": {
    "modificationConfirmed": "Muutosilmoitus on lähetetty",
    "modificationPending": "Muutosilmoitus on lähetetty ja odottaa muiden osapuolten hyväksyntää",
    "modificationRejected": "Muutosilmoituksen lähetys on peruttu",
    "modificationNotFound": "Muutosilmoituksen lähetystunnuksella ei löydy tietoja",
    "modificationLoading": "Ladataan muutosilmoituksen lähetyksen tilaa...",
    "addTenantSuccess": "Muutos on tallennettu"
  }
}
